import { DateTime } from 'luxon';
import {
  CouponBenefitDetailsDTO,
  CreditCardBenefitDetailsDTO,
  FitnessBenefitDetailsDTO,
  WellpassBenefitDetailsDTO,
} from 'probonio-shared-ui/api';
import { NonCashBenefit } from '../consts/consts';
import { NonCashBenefitStatusConfig, NonCashStatus } from './useNonCashBenefitState';

export const useNonCashBenefitUsage = (
  benefitDetails: CreditCardBenefitDetailsDTO | FitnessBenefitDetailsDTO | WellpassBenefitDetailsDTO | undefined,
  couponsDetails: CouponBenefitDetailsDTO | undefined,
  benefit: NonCashBenefit,
): { status: NonCashStatus; usageBenefit: NonCashBenefit } | undefined => {
  if (!couponsDetails || !benefitDetails?.nextStartDate) {
    return;
  }

  if (
    DateTime.fromISO(benefitDetails.nextStartDate).hasSame(DateTime.utc(), 'month') &&
    couponsDetails.activeNonCashBenefit &&
    couponsDetails.activeNonCashBenefit !== benefit
  ) {
    return { status: NonCashBenefitStatusConfig.OtherUsage, usageBenefit: couponsDetails.activeNonCashBenefit };
  }
  if (
    DateTime.fromISO(benefitDetails.nextStartDate).hasSame(DateTime.utc().plus({ month: 1 }), 'month') &&
    couponsDetails.activeNonCashBenefitNextMonth &&
    couponsDetails.activeNonCashBenefitNextMonth !== benefit
  ) {
    return { status: NonCashBenefitStatusConfig.OtherUsage, usageBenefit: couponsDetails.activeNonCashBenefitNextMonth };
  }
};
